import { render, staticRenderFns } from "./ContratoSP.vue?vue&type=template&id=1772a35c"
import script from "./ContratoSP.vue?vue&type=script&lang=js"
export * from "./ContratoSP.vue?vue&type=script&lang=js"
import style0 from "./ContratoSP.vue?vue&type=style&index=0&id=1772a35c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports